import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { includes, isEmpty, map } from 'lodash-es'
import { optionByName } from 'app-redux/selectors'
import useTerm from './useTerm'

// Hook untuk handle show columns
const useShowColumns = ({ name }) => {
  const { formatMessage } = useIntl()

  const optionColumns = useSelector((state) => optionByName(state, name))
  const term = useTerm()

  const parseColumns = useMemo(() => {
    const templateColumns = {
      show_columns_finance_bank_trans: {
        columns: [
          { label: formatMessage({ id: 'financeBanks.date' }), name: 'trans_date', enable: true },
          {
            label: formatMessage({ id: 'financeContacts.transaction_number' }),
            name: 'ref_number',
          },
          { label: formatMessage({ id: 'financeBanks.description' }), name: 'desc', enable: true },
          { label: term.reference, name: 'memo', enable: true },
          { label: term.tag, name: 'tags', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.received' }),
            name: 'received',
            enable: true,
          },
          { label: formatMessage({ id: 'financeBanks.spent' }), name: 'spent', enable: true },
          { label: formatMessage({ id: 'financeBanks.balance' }), name: 'balance', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.status' }),
            name: 'status_id',
            enable: true,
          },
        ],
        addonColumns: 'business_tran_id,trans_type_id',
      },
      show_columns_finance_bank_trans_void: {
        columns: [
          { label: formatMessage({ id: 'financeBanks.date' }), name: 'trans_date', enable: true },
          { label: formatMessage({ id: 'financeBanks.description' }), name: 'desc', enable: true },
          { label: term.reference, name: 'memo', enable: true },
          { label: term.tag, name: 'tags', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.received' }),
            name: 'received',
            enable: true,
          },
          { label: formatMessage({ id: 'financeBanks.spent' }), name: 'spent', enable: true },
          { label: formatMessage({ id: 'financeBanks.balance' }), name: 'balance', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.status' }),
            name: 'status_id',
            enable: true,
          },
        ],
        addonColumns: 'business_tran_id,trans_type_id',
      },
      show_columns_finance_invoices: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number_2' }),
            name: 'index_number',
          },
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.preorder_number' }),
            name: 'order_number',
          },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.customer, name: 'contact_id', enable: true },
          { label: formatMessage({ id: 'financeContacts.npwp' }), name: 'npwp' },
          {
            label: term.sales_person,
            name: 'sales_person',
          },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          { label: formatMessage({ id: 'shipping.shipping_date' }), name: 'shipping_date' },
          {
            label: formatMessage({ id: 'financeInvoices.payment_date' }),
            name: 'payment_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.paid_date' }),
            name: 'paid_date',
          },
          { label: formatMessage({ id: 'sales.overdue' }), name: 'due_days' },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.balance_due' }),
            name: 'due',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'financeInvoices.deliveryPrintStatus' }),
            name: 'delivery_print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_account' }),
            name: 'payment_account',
          },
          {
            label: formatMessage({ id: 'financeInvoices.receipt_number' }),
            name: 'shipping_tracking',
          },
          {
            label: formatMessage({ id: 'financeInvoices.created_at' }),
            name: 'created_at',
          },
          {
            label: formatMessage({ id: 'button.return' }),
            name: 'return_ref_number',
          },
          {
            label: formatMessage({ id: 'productionPlan.transaction_status' }),
            name: 'production_plan_status',
          },
          {
            label: formatMessage({ id: 'productionPlan.transaction_numbers' }),
            name: 'production_plan_numbers',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_deliveries: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.customer, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_orders: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'financeOrder.not_sent_yet' }),
            name: 'qty_unshipped',
          },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.customer, name: 'contact_id', enable: true },
          {
            label: term.sales_person,
            name: 'sales_person',
          },

          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_status' }),
            name: 'payment_status',
          },
          {
            label: formatMessage({ id: 'financeOrder.dp' }),
            name: 'dp',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          { label: formatMessage({ id: 'financeOrder.amount_unbilled' }), name: 'unbilled_amount' },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
          {
            label: formatMessage({ id: 'productionPlan.transaction_status' }),
            name: 'production_plan_status',
          },
          {
            label: formatMessage({ id: 'productionPlan.transaction_numbers' }),
            name: 'production_plan_numbers',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_quotes: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },

          { label: term.customer, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },

          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'sales.overdue' }),
            name: 'due_days',
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          {
            label: formatMessage({ id: 'financeQuotes.total_after_additional_discount' }),
            name: 'total_after_discount',
          },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_purchaseInvoices: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number_2' }),
            name: 'index_number',
          },
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.preorder_number' }),
            name: 'order_number',
          },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.vendor, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'appSetting.date_created' }),
            name: 'created_at',
          },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date' }),
            name: 'trans_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          { label: formatMessage({ id: 'shipping.shipping_date' }), name: 'shipping_date' },
          {
            label: formatMessage({ id: 'financeInvoices.payment_date' }),
            name: 'payment_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.paid_date' }),
            name: 'paid_date',
          },
          { label: formatMessage({ id: 'sales.overdue' }), name: 'due_days' },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.balance_due' }),
            name: 'due',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_account' }),
            name: 'payment_account',
          },
          {
            label: formatMessage({ id: 'financeInvoices.receipt_number' }),
            name: 'shipping_tracking',
          },
          {
            label: formatMessage(
              { id: 'financeInvoices.contact_bank_account' },
              { something: term.vendor },
            ),
            name: 'bank_account',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_purchaseDeliveries: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.vendor, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_purchaseOrders: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },
          {
            label: formatMessage({ id: 'financeOrder.not_sent_yet' }),
            name: 'qty_unshipped',
          },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.vendor, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_status' }),
            name: 'payment_status',
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          { label: formatMessage({ id: 'financeOrder.amount_unbilled' }), name: 'unbilled_amount' },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
          {
            label: formatMessage(
              { id: 'financeInvoices.contact_bank_account' },
              { something: term.vendor },
            ),
            name: 'bank_account',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_purchaseQuotes: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.vendor, name: 'contact_id', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.qty' }),
            name: 'qty',
          },

          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'sales.overdue' }),
            name: 'due_days',
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },

          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },

          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_products: {
        columns: [
          { label: formatMessage({ id: 'financeContacts.photo' }), name: 'photo' },
          { label: formatMessage({ id: 'financeProduct.name' }), name: 'name', enable: true },
          { label: formatMessage({ id: 'financeProduct.description' }), name: 'description' },
          {
            label: formatMessage(
              { id: 'financeProduct.bundle_type_id_with_title' },
              {
                product: term.product,
              },
            ),
            name: 'bundle_type_id',
            enable: true,
          },
          { label: formatMessage({ id: 'financeProduct.code_sku' }), name: 'code', enable: true },
          {
            label: formatMessage({ id: 'financeProduct.categories' }),
            name: 'category',
            enable: true,
          },
          { label: formatMessage({ id: 'financeProduct.unit' }), name: 'unit_id', enable: true },
          {
            label: formatMessage({ id: 'financeProduct.other_units' }),
            name: 'other_units',
          },
          {
            label: formatMessage({ id: 'financeProduct.other_units_compact' }),
            name: 'other_units_compact',
          },
          {
            label: formatMessage({ id: 'financeProduct.cost_price' }),
            name: 'base_price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.sale_price' }),
            name: 'price',
            enable: true,
          },
          { label: formatMessage({ id: 'financeProduct.qty' }), name: 'qty', enable: true },
          {
            label: formatMessage({ id: 'financeProduct.avg_base_price' }),
            name: 'hpp',
            enable: true,
          },
          { label: formatMessage({ id: 'marketplaceConnect.marketplace' }), name: 'marketplace' },
        ],
        addonColumns: '',
      },
      show_columns_finance_accounts: {
        columns: [
          {
            label: `${formatMessage({ id: 'financeAccounts.account_name' })} (ID)`,
            name: 'name',
            enable: true,
          },
          {
            label: `${formatMessage({ id: 'financeAccounts.account_name' })} (EN)`,
            name: 'name_en',
          },
          {
            label: formatMessage({ id: 'financeAccounts.category' }),
            name: 'category',
            enable: true,
          },
        ],
      },
      show_columns_finance_expenses: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.date' }),
            name: 'trans_date',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.due_date' }), name: 'due_date' },

          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: 'Item', name: 'item' },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeExpenses.benefeciary' }),
            name: 'contact_id',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_date' }),
            name: 'payment_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.paid_date' }),
            name: 'paid_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.balance_due' }),
            name: 'due',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.payment_account' }),
            name: 'payment_account',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_contacts: {
        columns: [
          {
            label: formatMessage({ id: 'financeContacts.photo' }),
            name: 'photo',
          },
          {
            label: formatMessage({ id: 'financeContacts.contact_name' }),
            name: 'name',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeContacts.contact_type' }),
            name: 'type',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeContacts.company' }),
            name: 'company',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeContacts.address' }),
            name: 'address',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeContacts.email' }),
            name: 'email',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeContacts.phone' }),
            name: 'phone',
            enable: true,
          },
          {
            label: formatMessage(
              { id: 'financeContacts.you_owe_with_title' },
              {
                credit: term.payable,
              },
            ),
            name: 'payable',
          },

          {
            label: formatMessage(
              { id: 'financeContacts.they_owe_with_title' },
              {
                credit: term.payable,
              },
            ),
            name: 'receivable',
          },
          {
            label: formatMessage({ id: 'financeContacts.group' }),
            name: 'group',
          },
          {
            label: formatMessage({ id: 'financeContacts.shipping_address' }),
            name: 'shipping_address',
          },
          {
            label: formatMessage({ id: 'financeContacts.village' }),
            name: 'village',
          },
          {
            label: formatMessage({ id: 'financeContacts.district' }),
            name: 'district',
          },
          {
            label: formatMessage({ id: 'report.number' }),
            name: 'ref_number',
          },
          {
            label: formatMessage({ id: 'financeContacts.default_term' }),
            name: 'finance_term_id',
          },
          {
            label: formatMessage({ id: 'audit.description' }),
            name: 'description',
          },
          {
            label: formatMessage({ id: 'financeContacts.date_of_birth' }),
            name: 'birthday',
          },
          {
            label: 'Geo Tagging',
            name: 'geo_tagged',
          },
        ],
        addonColumns: '',
      },
      show_columns_stock_movements: {
        columns: [
          {
            label: formatMessage({ id: 'report.date' }),
            name: 'trans_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.transaction' }),
            name: 'trans_type',
            enable: true,
          },
          {
            label: term.reference,
            name: 'reference',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.description' }),
            name: 'desc',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.price' }),
            name: 'price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.avg_base_price' }),
            name: 'avg_price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.stock_movement' }),
            name: 'qty_movement',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.stock' }),
            name: 'qty',
            enable: true,
          },
        ],
        addonColumns: '',
      },
      show_columns_reporting_inventory_stock_movement: {
        columns: [{ label: term.reference, name: 'reference' }],
        addonColumns: '',
      },
      show_columns_reporting_inventory_stock_adjustment_detail: {
        columns: [{ label: term.reference, name: 'reference' }],
        addonColumns: '',
      },
      show_columns_reporting_warehouse_stock_movement: {
        columns: [{ label: term.reference, name: 'reference' }],
        addonColumns: '',
      },
      show_columns_reporting_return_per_product: {
        columns: [
          {
            label: formatMessage({ id: 'report.product_name_with_title' }, { title: term.product }),
            name: 'product_name',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.code_sku' }),
            name: 'product_code',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.category' }),
            name: 'product_category',
          },
          {
            label: formatMessage({ id: 'report.current_unit_price' }),
            name: 'product_price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.return_amount' }),
            name: 'qty',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.total_return' }),
            name: 'amount',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.total_after_tax' }),
            name: 'amount_after_tax',
          },
          {
            label: formatMessage({ id: 'report.average' }),
            name: 'avg',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.avg_after_tax' }),
            name: 'avg_after_tax',
          },
        ],
        addonColumns: '',
      },
      show_columns_reporting_purchase_return_per_product: {
        columns: [
          {
            label: formatMessage({ id: 'report.product_name_with_title' }, { title: term.product }),
            name: 'product_name',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeProduct.code_sku' }),
            name: 'product_code',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.category' }),
            name: 'product_category',
          },
          {
            label: formatMessage({ id: 'report.current_unit_price' }),
            name: 'product_price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.return_amount' }),
            name: 'qty',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.total_return' }),
            name: 'amount',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.total_after_tax' }),
            name: 'amount_after_tax',
          },
          {
            label: formatMessage({ id: 'report.average' }),
            name: 'avg',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.avg_after_tax' }),
            name: 'avg_after_tax',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_fixed_asset: {
        columns: [
          {
            label: formatMessage({ id: 'financeContacts.photo' }),
            name: 'photo',
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.asset_name' }),
            name: 'name',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.purchase_invoice' }),
            name: 'purchase_invoice_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: term.reference,
            name: 'reference',
            enable: true,
          },
          {
            label: term.tag,
            name: 'tags',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.purchase_date' }),
            name: 'trans_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.disposal_date' }),
            name: 'disposal_date',
            // enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.disposal_price' }),
            name: 'sale_price',
            // enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.purchase_price' }),
            name: 'purchase_price',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.book_value' }),
            name: 'book_value',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.gain' }),
            name: 'loss_gain_on_disposal',
            // enable: true,
          },
          {
            label: formatMessage({ id: 'financeFixedAssets.total_asset_upgrade' }),
            name: 'total_upgrade',
          },
        ],
        addonColumns: '',
      },
      show_columns_reporting_aged_receivable: {
        columns: [
          { label: term.customer, name: 'name' },
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
        ],
        addonColumns: '',
      },
      show_columns_reporting_aged_payable: {
        columns: [
          { label: term.vendor, name: 'name' },
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
        ],
        addonColumns: '',
      },
      show_columns_reporting_balance_receivable_termin: {
        columns: [
          { label: term.customer, name: 'name' },
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
        ],
        addonColumns: '',
      },
      show_columns_reporting_balance_payable_termin: {
        columns: [
          { label: term.vendor, name: 'name' },
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
        ],
        addonColumns: '',
      },
      show_columns_reporting_customer_receivable_snapshot: {
        columns: [
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
          { label: formatMessage({ id: 'financeContacts.phone' }), name: 'phone' },
        ],
        addonColumns: '',
      },
      show_columns_reporting_customer_debt_snapshot: {
        columns: [
          { label: formatMessage({ id: 'financeContacts.company' }), name: 'company' },
          { label: formatMessage({ id: 'financeContacts.phone' }), name: 'phone' },
        ],
        addonColumns: '',
      },
      show_columns_finance_proforma_orders: {
        columns: [
          {
            label: formatMessage({ id: 'financeInvoices.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.attachments' }),
            name: 'attachment_exists',
          },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeWareHouses.warehouse_name' }),
            name: 'warehouse',
          },
          { label: term.customer, name: 'contact_id', enable: true },
          {
            label: term.sales_person,
            name: 'sales_person',
          },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date', enable: true }),
            name: 'trans_date',
          },
          {
            label: formatMessage({ id: 'financeInvoices.due_date' }),
            name: 'due_date',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          {
            label: formatMessage({ id: 'financeInvoices.status' }),
            name: 'status_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeOrder.dp' }),
            name: 'dp',
            enable: true,
          },
          { label: formatMessage({ id: 'financeInvoices.total_before_tax' }), name: 'amount' },
          { label: formatMessage({ id: 'financeOrder.amount_unbilled' }), name: 'unbilled_amount' },
          {
            label: formatMessage({ id: 'financeInvoices.total' }),
            name: 'amount_after_tax',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.printStatus' }),
            name: 'print_status',
          },
          {
            label: formatMessage({ id: 'item_description' }),
            name: 'item_desc',
          },
        ],
        addonColumns: '',
      },
      show_columns_finance_invoice_returns: {
        columns: [
          {
            label: formatMessage({ id: 'report.number' }),
            name: 'ref_number',
            enable: true,
          },
          {
            label: 'Attachment',
            name: 'attachment',
            enable: true,
          },
          {
            label: formatMessage({ id: 'financeInvoices.invoice_number' }),
            name: 'invoice_ref_number',
          },
          {
            label: term.reference,
            name: 'memo',
            enable: true,
          },
          {
            label: term.customer,
            name: 'contact_id',
            enable: true,
          },
          {
            label: formatMessage({ id: 'report.date' }),
            name: 'trans_date',
            enable: true,
          },
          {
            label: 'Total',
            name: 'amount_after_tax',
            enable: true,
          },
        ],
        addonColumns: '',
      },
      show_columns_delivery_recap_items_per_delivery: {
        columns: [
          { label: formatMessage({ id: 'report.number' }), name: 'ref_number', enable: true },
          { label: 'Attachment', name: 'attachment_exists' },
          { label: term.reference, name: 'memo', enable: true },
          { label: formatMessage({ id: 'financeWareHouses.warehouse_name' }), name: 'warehouse' },
          { label: term.customer, name: 'contact_id', enable: true },
          { label: formatMessage({ id: 'report.qty' }), name: 'qty', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date' }),
            name: 'trans_date',
            enable: true,
          },
          { label: formatMessage({ id: 'financeExpenses.term' }), name: 'termin' },
          { label: term.tag, name: 'tags' },
          { label: formatMessage({ id: 'item_description' }), name: 'item_desc' },
          {
            label: formatMessage({ id: 'financeContacts.opening_hour' }),
            name: 'opening_hour',
            enable: true,
          },
          { label: 'Volume', name: 'volume', enable: true },
          { label: formatMessage({ id: 'weight' }), name: 'weight', enable: true },
        ],
      },
      show_columns_delivery_recap_items_per_product: {
        columns: [
          { label: 'No', name: 'number', enable: true },
          { label: term.product, name: 'product_id', enable: true },
          { label: formatMessage({ id: 'report.qty' }), name: 'qty', enable: true },
          { label: formatMessage({ id: 'financeUnits.unit' }), name: 'unit_id', enable: true },
          { label: 'Volume', name: 'volume', enable: true },
          { label: formatMessage({ id: 'weight' }), name: 'weight', enable: true },
        ],
      },
      show_columns_delivery_recaps: {
        columns: [
          { label: formatMessage({ id: 'report.number' }), name: 'ref_number', enable: true },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'financeBanks.transaction_date' }),
            name: 'trans_date',
            enable: true,
          },
          {
            label: formatMessage({ id: 'shipping.shipping_expedition' }),
            name: 'shipping_comp_id',
            enable: true,
          },
          { label: formatMessage({ id: 'zap.fleet' }), name: 'fleet_id', enable: true },
          { label: 'Driver', name: 'driver_id', enable: true },
          { label: term.tag, name: 'tags' },
          { label: formatMessage({ id: 'report.shipping_amount' }), name: 'shipping_qty' },
          { label: formatMessage({ id: 'zap.warehouse_start' }), name: 'start_warehouse' },
          { label: formatMessage({ id: 'zap.warehouse_end' }), name: 'end_warehouse' },
          { label: 'Status', name: 'status_id', enable: true },
        ],
      },
      show_columns_invoice_recaps: {
        columns: [
          { label: formatMessage({ id: 'report.number' }), name: 'ref_number', enable: true },
          { label: term.reference, name: 'memo', enable: true },
          { label: formatMessage({ id: 'report.date' }), name: 'trans_date', enable: true },
          { label: formatMessage({ id: 'collector' }), name: 'collector_id', enable: true },
          { label: 'Status', name: 'status', enable: true },
          {
            label: formatMessage({ id: 'financeInvoices.balance_due' }),
            name: 'due',
            enable: true,
          },
          { label: 'Total', name: 'amount', enable: true },
        ],
      },
      show_columns_canvassing: {
        columns: [
          { label: formatMessage({ id: 'report.number' }), name: 'ref_number', enable: true },
          { label: term.reference, name: 'memo', enable: true },
          {
            label: formatMessage({ id: 'priceRule.date_start' }),
            name: 'start_time',
            enable: true,
          },
          { label: formatMessage({ id: 'report.end_date' }), name: 'end_time', enable: true },
          {
            label: formatMessage({ id: 'zap.canvassing_total_days' }),
            name: 'total_days',
            enable: true,
          },
          { label: 'Sales', name: 'sales_id', enable: true },
          { label: 'Status', name: 'status', enable: true },
          { label: term.tag, name: 'tags', enable: true },
          {
            label: formatMessage(
              { id: 'financeInvoices.product_type_with_title' },
              { title: term.product },
            ),
            name: 'product_type',
            enable: true,
          },
          {
            label: formatMessage({ id: 'zap.canvassing_qty_item' }),
            name: 'qty_item',
            enable: true,
          },
          { label: formatMessage({ id: 'dashboards.sales' }), name: 'total_sales', enable: true },
          {
            label: 'Checkin',
            name: 'amount_checkin',
            enable: true,
          },
        ],
      },
      show_columns_reporting_profit_loss: {
        columns: [
          { label: 'Delta', name: 'delta' },
          { label: formatMessage({ id: 'report.cogs_percentage' }), name: 'percent_of_parent' },
        ],
      },
      show_columns_reporting_journal: {
        columns: [{ label: formatMessage({ id: 'financeTag.financeTag' }), name: 'tags' }],
      },
      show_columns_mp_products: {
        columns: [
          { label: formatMessage({ id: 'financeContacts.photo' }), name: 'photo' },
          { label: formatMessage({ id: 'financeProduct.name' }), name: 'name', enable: true },
          { label: formatMessage({ id: 'financeProduct.code_sku' }), name: 'code', enable: true },
          // TODO: kategori sementara tidak dipakai
          // {
          //   label: formatMessage({ id: 'financeProduct.categories' }),
          //   name: 'category',
          //   enable: true,
          // },
          {
            label: formatMessage({ id: 'financeProduct.sale_price' }),
            name: 'price',
            enable: true,
          },
          { label: formatMessage({ id: 'financeProduct.qty' }), name: 'qty', enable: true },
        ],
        addonColumns: '',
      },
    }
    const foundTemplateColumn = templateColumns[name]
    const templateColumn = foundTemplateColumn?.columns || []

    let _columns = templateColumn
    if (Array.isArray(templateColumn) && !isEmpty(optionColumns)) {
      let currentValues = []
      if (Array.isArray(optionColumns)) {
        currentValues = optionColumns
      } else {
        currentValues = optionColumns.split(',')
      }
      _columns = templateColumn
        .filter((row) => row.enable !== false)
        .map((row) => {
          return { ...row, enable: includes(currentValues, row.name) }
        })
    }

    const enabledColumns = map(
      _columns.filter((row) => row.enable),
      'name',
    )
    if (!isEmpty(foundTemplateColumn?.addonColumns)) {
      enabledColumns.push(foundTemplateColumn?.addonColumns)
    }

    return { columns: _columns, toStringColumns: enabledColumns.join(','), enabledColumns, term }
  }, [formatMessage, name, optionColumns, term])

  return parseColumns
}

export default useShowColumns
